import { Box, Button, Divider, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'
import { DATES_PRESELECTION } from '../../enums/datePreselection.enum'
import { useTranslation } from 'react-i18next'

function DatePreselectoions({
  selectedPeriod,
  onPerodChange
}: {
  selectedPeriod: string | null
  onPerodChange: (value: string | null) => void
}) {

  const { t } = useTranslation()
  return (
    <FormControl size='small' fullWidth sx={{ my: 2 }}>
      <InputLabel id="demo-simple-select-label">{t('period')}</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={selectedPeriod}

        fullWidth
        label={t('period')}
        onChange={(e) => {

          onPerodChange(e.target.value ?? null)
        }}
      >
        <MenuItem value={""}></MenuItem>

        {
          DATES_PRESELECTION.map(date =>
            <MenuItem value={date.value}>{t(date.title)}</MenuItem>
          )
        }

      </Select>
    </FormControl>
  )
}

export default DatePreselectoions